import { getStoreConfig } from 'config'
import { getTrimmedUrl } from './getTrimmedUrl'
export const getCanonical = (
    pathname: string,
    locale?: string,
    isCustomPath?: boolean
) => {
    const config = getStoreConfig(locale)
    const { base } = config
    return `${base.url.baseUrl}${
        isCustomPath ? pathname : getTrimmedUrl(pathname)
    }`
}
